import { Dialog } from '@hub/common/Dialog/Dialog';
import { useState } from 'react';

export interface IglideStandardModalProps {
  header: string;
  activeModal: boolean;
  setActiveModal: (value: boolean) => void;
}

export const IglideStandardModal = ({ header, activeModal, setActiveModal }: IglideStandardModalProps) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  return (
    <Dialog
      closable
      fullScreen
      visible={activeModal}
      onClose={() => {
        setIsFullScreen(false);
        setActiveModal(false);
      }}
      onSetFullScreen={setIsFullScreen}
    >
      <div
        className={`${isFullScreen ? 'w-[100vw] h-[100vh] pr-[16px]' : 'w-[60vw] h-[70vh]'} pt-16`}
        data-testid="iglide-standards-pdf"
      >
        <h3 className="p-[16px] pt-0">{header}</h3>
        <iframe
          src="https://igus.widen.net/view/pdf/iy2zczzrue/BRG_DS_informative_document_to_support_iglide_and_igus_U.S.A._EN_1.pdf"
          className="w-full h-full"
          title="iglide® standards PDF"
          data-testid="widen-pdf"
        />
      </div>
    </Dialog>
  );
};
